import React from "react";
import { connect } from "react-redux";
import mapFetchToProps from "../mapFetchToProps";

export const withDataMapping = (BaseComponent) => {
  return connect(mapFetchToProps)(BaseComponent);
};
